import Head from "next/head";
import Link from "next/link";

import config from "config";

import Skeleton from "ui-components/Skeleton";

import { AuthLayout } from "auth";
import { useGetUserDetails } from "auth/auth-state";

const Layout = ({ children }: { children: React.ReactNode }) => {
  const userDetails = useGetUserDetails();

  if (!userDetails) {
    return <Skeleton />;
  }

  const { usage } = userDetails;
  const dataAccessPlan =
    // @ts-ignore
    userDetails.access_plan || userDetails.data_access_plan;

  if (
    dataAccessPlan.allowed_projects >= 1 &&
    usage.projects >= dataAccessPlan.allowed_projects
  ) {
    return (
      <div>
        <h1 className="h2 text-center">Exceeded Plan Limits</h1>
        <p className="text-center mt-4 text-xl">
          Your plan allows for{" "}
          {dataAccessPlan.allowed_projects.toLocaleString()} projects. You
          already have {usage.projects.toLocaleString()} projects!
        </p>
        {config.DEPLOY_ENV === "daisho-cloud" ? (
          <p className="text-center mt-4 text-xl">
            <Link href="/profile/billing">
              <a className="text-primary-main underline">Click here</a>
            </Link>{" "}
            to change your plan.
          </p>
        ) : (
          <p className="text-center mt-4 text-xl">
            Contact your administrator @ {config.ADMIN_CONTACT} for more
            details, and next steps.
          </p>
        )}
      </div>
    );
  }

  return <>{children}</>;
};

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <AuthLayout>
    <Head>
      <title>{config.SITE_NAME} | Create New Project</title>
    </Head>
    <Layout>{children}</Layout>
  </AuthLayout>
);

export default Wrapper;
